import axios from "axios";
import Swal from "sweetalert2";
import { sidebarItems } from "./SideBarItems";


axios.interceptors.response.use(
  (response) => {
    const authToken = localStorage.getItem("Admin");
    const userData = JSON.parse(authToken);
    const userRole = userData?.data?.role;
    const permissions = authToken ? JSON.parse(authToken)?.data?.permission : [];
    // Build route -> pageId map
    if (userRole === 'adsales' || userRole === 'admanager' || userRole === 'adaccountant' || userRole === 'adsupport') {

    const routePageMap = sidebarItems.reduce((map, item) => {
      if (item.pageId) {
        map[item.to] = item.pageId;
      }
      if (item.subItems) {
        item.subItems.forEach((subItem) => {
          if (subItem.pageId) {
            map[subItem.to] = subItem.pageId;
          }
        });
      }
      return map;
    }, {});

    // 🔑 Get current pathname
    const currentPath = window.location.pathname;
    const requestedPageId = routePageMap[currentPath];

    // ✅ Validate permissions
    if (requestedPageId && !permissions.includes(requestedPageId)) {
      Swal.fire({
        title: "Access Denied",
        text: "You don’t have permission to access this resource.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCDD00",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let role = JSON.parse(localStorage.getItem("Admin"))?.data?.role;
          if (role === 'adsales' || role === 'admanager' || role === 'adaccountant' || role === 'adsupport') {
            const permissions = JSON.parse(localStorage.getItem("Admin"))?.data?.permission; 
            const findFirstAllowedPage = (items, allowedIds) => {
            for (const item of items) {
             if (item.subItems) {
               const subPage = findFirstAllowedPage(item.subItems, allowedIds);
               if (subPage) return subPage;
             } else if (!item.pageId || allowedIds.includes(item.pageId)) {
               return item.to; 
             }
            }
            return null;
          };
            window.location.href = findFirstAllowedPage(sidebarItems, permissions);
          } else {
            window.location.href = "/login";
          }
        }
      });
      return Promise.reject(new Error("Access Denied"));
    }
   }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      Swal.fire({
        title: "Authentication Error",
        text: "Your session has expired. Please log in again.",
        icon: "error",
        confirmButtonText: "Login",
        confirmButtonColor: "#FCDD00",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          let role = JSON.parse(localStorage.getItem("Admin"))?.data?.role;
          if (role === 'adsales' || role === 'admanager' || role === 'adaccountant' || role === 'adsupport') {
            window.location.href = "/admin/admin_team/login";
          } else {
            window.location.href = "/login";
          }
          localStorage.removeItem("Admin");
        }
      });
    }

     // Handle 403 Forbidden
     if (error.response.status === 403) {
      Swal.fire({
        title: "Access Denied",
        text: "You don’t have permission to access this resource.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#FCDD00",
        allowOutsideClick: false,
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let role = JSON.parse(localStorage.getItem("Admin"))?.data?.role;
          if (role === 'adsales' || role === 'admanager' || role === 'adaccountant' || role === 'adsupport') {
            const permissions = JSON.parse(localStorage.getItem("Admin"))?.data?.permission; 
            const findFirstAllowedPage = (items, allowedIds) => {
            for (const item of items) {
             if (item.subItems) {
               const subPage = findFirstAllowedPage(item.subItems, allowedIds);
               if (subPage) return subPage;
             } else if (!item.pageId || allowedIds.includes(item.pageId)) {
               return item.to; 
             }
            }
            return null;
          };
            window.location.href = findFirstAllowedPage(sidebarItems, permissions);
          } else {
            window.location.href = "/login";
          }
        }
      });
    }
    return Promise.reject(error);
  }
);
